module.exports = __webpack_public_path__ + "static/img/logo7.30003cf8.png";